"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @param low inclusive, must be true on predicate function
 * @param high exclusive,
 * @param predicate predicate function
 */
var bsearch = function (low, high, predicate) {
    var mid = Math.floor((low + high) / 2);
    if (mid === low)
        return mid;
    if (predicate(mid))
        return bsearch(mid, high, predicate);
    else
        return bsearch(low, mid, predicate);
};
exports.default = bsearch;
